import React, { useState, useEffect } from 'react';

import { useHelpBundle } from '@plasma/ui.application.app';
import { useResourceBundle, useTranslation } from '@plasma/ui.utils.i18n';

import translations from './i18n';
import { ZoneMasterProps } from './zone-master';
import help from './zone-master.help';

import { fetchAllDataGet_byApiName } from '../../services/gets/getdata';
import { sendAllDataPost_byApiNameAndData } from '../../services/posts/postdata';
import zoneMasterColumns from '../../types/zoneMasterDataType';
import notification from '@plasma/ui.feedback.notification';
import { deleteDataFromApiWithBody } from '../../services/Deletes/deleteData';
import { apiUriMasterDataHttp } from '../../services/conf/apiConf';

function useZoneMasterHook(props: ZoneMasterProps) {
  useResourceBundle(translations, undefined, '0a150a89-c7a3-4f92-868b-0541afae38ef');
  useHelpBundle(help);

  const { t } = useTranslation();

  const [dataForColumns, setdataForColumns] = useState([])
  const [columnNames, setcolumnNames] = useState(zoneMasterColumns());

  useEffect(() => {
    fetchAllDataGet_byApiName("GetMasterZones", apiUriMasterDataHttp()).then((data) => {
      setdataForColumns(data);

    }).catch((error)=>{
      console.log("Failed to Fetch Areas");
    });
  },[]);


  const handleSaveAndDeleteFromTable = (data, returnType) =>{

    if (returnType === 'delete'){
      console.log(data);
      deleteDataFromApiWithBody('DeleteMasterZone', data, apiUriMasterDataHttp())
      .then((response) => {
        if(response){
          fetchAllDataGet_byApiName("GetMasterZones", apiUriMasterDataHttp()).then((data) => {
            setdataForColumns(data);
            notification.success('Removed !', 'Data Deleted Permanently', undefined, 'medium', 3)
          }).catch((error)=>{
            console.log("Failed to EditPlantLayout");
          });
        }
      }).catch((error) => {
        console.log(error);
        notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
      });
    }
    else {
      if(data.displayseq === ''){
        data.displayseq = 0;
        }

      data.displayseq = parseFloat(data.displayseq);

      if (data.isactive === '' ) {
        data.isactive = false ;
        }
      //console.log(data);

      sendAllDataPost_byApiNameAndData('AddMasterZone', data, apiUriMasterDataHttp())
        .then((response) => {
          if(response){
            fetchAllDataGet_byApiName("GetMasterZones", apiUriMasterDataHttp()).then((data) => {
              setdataForColumns(data);
              notification.success('Success !', 'Data Saved Successfully', undefined, 'medium', 3)
            }).catch((error)=>{
              console.log("Failed to EditPlantLayout");
            });
          }
        }).catch((error) => {
          console.log(error);
          notification.error('Error !', 'Unsuccessful Attempt', undefined, 'medium', 3)
        });
    }

  };

  return {
    t,
    dataForColumns,
    columnNames,
    handleSaveAndDeleteFromTable
  };
}

export default useZoneMasterHook;
